module.exports = __webpack_public_path__ + "fc978da91d3fbbf578579d7c6aa66fb1.png";